import AuthForm from '../components/Auth/AuthForm';
import {useContext, useEffect} from "react";
import PatientContext from "../store/patient-context";


const AuthPage = () => {
  const patientCtx = useContext(PatientContext);

  useEffect(() => {
    patientCtx.clear();
  }, [patientCtx]);

  return (
    <section className={"page_content"}>
      <AuthForm />
    </section>);
};

export default AuthPage;
